import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("autorent-language") || "en";
  });

  useEffect(() => {
    localStorage.setItem("autorent-language", language);

    document.documentElement.lang =
      language === "sq" ? "sq" : "en";
  }, [language]);

  const changeLanguage = (newLanguage) => {
    if (newLanguage === "en" || newLanguage === "sq") {
      setLanguage(newLanguage);
    }
  };

  const toggleLanguage = () => {
    setLanguage((currentLanguage) =>
      currentLanguage === "en" ? "sq" : "en"
    );
  };

  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
        toggleLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error(
      "useLanguage must be used inside LanguageProvider"
    );
  }

  return context;
}